import { MobileInstrumentsDefinitions } from "./MobileInstrumentsDefinitions";
import MobileInstrumentsDesigner from "./MobileInstrumentsDesigner";

export class MobileInstruments extends MobileInstrumentsDefinitions {
    render() {
        return (
            <div
                data-schema-id={this.props.id}
                className={`fa-draggable fa-Section row ${this.props.designing ? "designing" : ""}`}
                style={{
                    minHeight: this.props.designing ? "300px" : "auto",
                    position: "relative",
                }}
            >
                {this.props.designing ? (
                    <MobileInstrumentsDesigner {...this.props} />
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}
